import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import MenuItem from 'material-ui/MenuItem';
import AutoComplete from './AutoComplete';
import SearchStore from '../../stores/SearchStore';
import { SearchTypes } from '../../constants/CentricConstants';

const SelectEntityFactory = (searchEntityAction, options = {}) => {
    const {
        minInput = 3,
        getTextValue = ({name}) => name,
        searchType = SearchTypes.DEFAULT,
    } = options;

    class SelectEntityComponent extends Component {

        componentDidMount() {
            this.onUpdate = this.onUpdate.bind(this);
            this.onSelect = this.onSelect.bind(this);
        }

        render() {
            const { searchText, items } = this.state;
            const maxSearchResults = Math.max(1, this.props.maxSearchResults); // ensuring 1 as minimum
            const match = searchText ? new RegExp(searchText, 'i') : {test: () => false};
            const data = items && items
                .map(item => ({id: item.id, name: getTextValue(item)}))
                .filter(({name}) => name && match.test(name))
                .slice(0, maxSearchResults)
                .map(({id, name}) => ({
                    id,
                    text: name,
                    value: <MenuItem key={id} value={id} primaryText={name} />
                }));

            return (
                <AutoComplete
                    searchText={searchText}
                    floatingLabelText={this.props.label}
                    maxSearchResults={maxSearchResults}
                    dataSource={data}
                    onUpdateInput={this.onUpdate}
                    onNewRequest={this.onSelect}
                    fullWidth={true}
                    isFetching={this.state.isFetching && (searchText.length >= minInput)}
                />
            );
        }

        onUpdate(input) {
            this.timeout && clearTimeout(this.timeout);
            if (input !== undefined && input.length >= minInput) {
                this.timeout = setTimeout(() => searchEntityAction(input), 500);
            }
            this.props.onUpdate && this.props.onUpdate(input);
            this.setState({searchText: input || ''});
        }

        onSelect({id, text}) {
            this.props.onSelect(text, id);
            if (this.props.clearOnSelect) {
                this.setState({searchText: ''});
            }
        }
    }

    SelectEntityComponent.getStores = () => ([SearchStore]);
    SelectEntityComponent.calculateState = (prevState) => ({
        searchText: (prevState && prevState.searchText) || '',
        isFetching: SearchStore.isFetching(searchType),
        items: SearchStore.getResults(searchType) || []
    });

    SelectEntityComponent.propTypes = {
        clearOnSelect: PropTypes.bool,
        label: PropTypes.string.isRequired,
        onSelect: PropTypes.func.isRequired,
        onUpdate: PropTypes.func
    };

    SelectEntityComponent.defaultProps = {
        clearOnSelect: true,
        maxSearchResults: 5,
    };

    return Container.create(SelectEntityComponent);
};

export default SelectEntityFactory;
